/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  FormFieldType,
  IFormSelect,
  IFormValidatable,
  RequiredValidations,
} from '../typings';
import { BaseFormFieldBuilder } from '.';

type Validations = RequiredValidations<IFormSelect['validations']>;

export class SelectFormFieldBuilder
  extends BaseFormFieldBuilder<IFormSelect>
  implements IFormValidatable<Validations>
{
  // @ts-ignore
  private _type = FormFieldType.Select as const;
  // @ts-ignore
  private _useShortName?: IFormSelect['useShortName'];
  // @ts-ignore
  private _canAddEntry?: IFormSelect['canAddEntry'];
  // @ts-ignore
  private _multiple?: IFormSelect['multiple'];
  // @ts-ignore
  private _options?: IFormSelect['options'];
  // @ts-ignore
  private _lookupEntryAddresses?: IFormSelect['lookupEntryAddresses'];
  // @ts-ignore
  private _rejectsPoBox?: IFormSelect['rejectsPoBox'];
  private _validations?: Validations;

  constructor() {
    super();
  }

  public useShortName(value: IFormSelect['useShortName']): this {
    this._useShortName = value;
    return this;
  }

  public canAddEntry(value: IFormSelect['canAddEntry']): this {
    this._canAddEntry = value;
    return this;
  }

  public multiple(value: IFormSelect['multiple']): this {
    this._multiple = value;
    return this;
  }

  public options(value: IFormSelect['options']): this {
    this._options = value;
    return this;
  }

  public lookupEntryAddresses(
    value: IFormSelect['lookupEntryAddresses'],
  ): this {
    this._lookupEntryAddresses = value;
    return this;
  }

  public rejectsPoBox(value: IFormSelect['rejectsPoBox']): this {
    this._rejectsPoBox = value;
    return this;
  }

  public validation(value: Validations[number]): this {
    if (this._validations) {
      this._validations.push(value);
    } else {
      this._validations = [value];
    }

    return this;
  }

  public validations(value: Validations): this {
    if (this._validations) {
      this._validations.push(...value);
    } else {
      this._validations = [...value];
    }

    return this;
  }
}
